import type { ReactElement } from 'react'
import type { Props as UserCardProps } from '~/components/UserCard'

import UserCard from '~/components/UserCard'
import { useUserDetailsQuery } from '~/queries/users'
import { getRelativeDate } from '~/utils/date'

interface Props extends Pick<UserCardProps, 'label' | 'labelPosition'> {
  createdAt?: number
  userId: string
}

const UserCardWithCall = ({ createdAt, label, labelPosition, userId }: Props): ReactElement => {
  const { data: user } = useUserDetailsQuery(userId)

  const computedCreatedAt = getRelativeDate(createdAt ? createdAt * 1000000 : 0)

  return (
    <UserCard
      label={label}
      labelPosition={labelPosition}
      name={user?.name || ''}
      picture={user?.picture}
      size="small"
      subInfo={computedCreatedAt}
    />
  )
}
export default UserCardWithCall
